import { logii } from "../../Utils.js";

export const getDefaultProps = {
    locale: void 0,
    onChange: (str) => {
        logii("[CronGeneratorProps] onChange needs override.");
    },
    options: void 0,
    showResultCron: false,
    showResultText: false,
    translateFn: void 0,
    value: void 0,
};

export function CronGenerator(props) {
    return null;
}

